exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*!\n * Website: https://www.4myth.com\n * Email: mythpe@gmail.com\n * Mobile: +966590470092\n * Copyright © 2018-2024  All rights reserved.\n * MyTh Ahmed\n */.v-avatar{align-items:center;border-radius:50%;display:inline-flex;justify-content:center;line-height:normal;position:relative;text-align:center;vertical-align:middle;overflow:hidden}.v-avatar img,.v-avatar svg,.v-avatar .v-icon,.v-avatar .v-image,.v-avatar .v-responsive__content{border-radius:inherit;display:inline-flex;height:inherit;width:inherit}", ""]);

// exports
